/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { Link } from "react-router-dom";
import { Link as MuiLink, Typography } from "@mui/material";
import { environment } from "../../environment";
import { FlaskIcon } from "../../FontAwesome";
import LanCloudLogo from './lan-cloud-logo.svg';
import "./AppTitle.scss";

export default function AppTitle() {
    return (
        <Typography variant="h1" className="lan-apptitle">
            <MuiLink
                component={Link}
                to={`/`}
                className="lan-apptitle__link"
                underline="hover">
                <img src={LanCloudLogo} className="lan-apptitle__logo" alt="LANcloud"/>
            </MuiLink>
            {environment.istBeta && <span className="lan-apptitle__beta"><FlaskIcon />{"Beta"}</span>}
        </Typography>
    );
}
